// Deterministic UI fixture shared by the schema/lifecycle help articles and
// the dev-only capture harness. This is deliberately NOT presented as an
// engine snapshot or verification example; it exists to exercise interface
// state transitions with stable values.
export const SCHEMA_SHEET_CAPTURE_FIXTURE = {
  kind: "deterministic interface capture fixture",
  calculatorId: "steel_beam_aisc",
  mark: "SB-1",
  shapeKey: "W18X50",
  gradeKey: "a992",
  gradeLabel: "ASTM A992",
  designMethod: "ASD",
  standard: "ANSI/AISC 360-22",
  unbracedLengthFt: 0,
  momentGradientCb: 1,
  initialMomentKipFt: 184,
  replacementMomentKipFt: 200,
  momentCapacityKipFt: 252,
  shearDemandKip: 30,
  shearCapacityKip: 96.7,
  rejectedMessage: "Required moment is outside this capture fixture's accepted range.",
} as const;
